import { render, staticRenderFns } from "./DashR_Result_TopBuyer.vue?vue&type=template&id=40a96531"
import script from "./DashR_Result_TopBuyer.vue?vue&type=script&lang=js"
export * from "./DashR_Result_TopBuyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports